import axios from "@/plugins/axios";

export default {
    getTiposLunas(modeloProductoId) {
        return axios.get('api/panel/tratamientos/relaciones/tipos-lunas',{
            params: { modelo_producto_id: modeloProductoId }
        });
    },
    getTratamientos() {
        return axios.get('api/panel/tratamientos/relaciones/tratamientos');
    },
    getTratamientosColor() {
        return axios.get('api/panel/tratamientos/relaciones/tratamientos-color');
    },
    getModales() {
        return axios.get('api/panel/tratamientos/relaciones/modales');
    },
    getAll(filters) {
        return axios.get('api/panel/tratamientos/relaciones', { params: filters });
    },
    store(data) {
        return axios.post('api/panel/tratamientos/relaciones', data);
    },
    update(id, data) {
        return axios.patch(`api/panel/tratamientos/relaciones/${id}`, data);
    },
    destroy(id) {
        return axios.delete(`api/panel/tratamientos/relaciones/${id}`);
    },
    reorder(relacionReordered) {
        return axios.post('api/panel/tratamientos/relaciones/reordenar', {
            lista_reordenada: relacionReordered,
        });
    }

}